import { INDICATION_QUOTE_MAPPINGS } from 'constants/shared-constants';

export const tryGetQuoteIsin = (isin: string): string =>
  INDICATION_QUOTE_MAPPINGS.find((mapping) => mapping.isin === isin)?.quoteIsin ?? isin;
